import { Injectable, TemplateRef } from '@angular/core';
import { ComponentType } from '@angular/cdk/portal';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDialogType, ConfirmDialogResult } from './confirm-dialog.model';
import { ConfirmComponent } from './confirm-popup/confirm-popup.component';

@Injectable({
  providedIn: 'root'
})
export class ConfirmDialogService {
  constructor(private matDialog: MatDialog) {}
  confirm(message: string, description: string, dialogType: ConfirmDialogType): Promise<ConfirmDialogResult> {
    const dialogRef = this.matDialog.open(ConfirmComponent, {
      data: { dialogType, message, description },
      autoFocus: false
    });
    return dialogRef.afterClosed().toPromise();
  }
}
